import { render, staticRenderFns } from "./CDMenuForm.vue?vue&type=template&id=df627090&scoped=true"
import script from "./CDMenuForm.vue?vue&type=script&lang=js"
export * from "./CDMenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df627090",
  null
  
)

export default component.exports